import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../../hooks/useApi";
import api from "../../../utils/api";
import "./Brands.scss";

const Brands = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { data, loading, refetch } = useApi(() => api.getAdminBrands(), []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this brand?")) {
      try {
        await api.deleteBrand(id);
        refetch();
      } catch (error) {
        console.error("Error deleting brand:", error);
        alert("Failed to delete brand");
      }
    }
  };

  const brands = data?.brands || [];
  const filteredBrands = brands.filter((brand) =>
    brand.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="admin-brands">
      <div className="brands-header">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search brands..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <Link to="/admin/brands/new" className="btn-primary">
          Add New Brand
        </Link>
      </div>

      {loading ? (
        <div className="loading">Loading brands...</div>
      ) : (
        <div className="brands-table">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Slug</th>
                <th>Description</th>
                <th>Image</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredBrands.length === 0 ? (
                <tr>
                  <td colSpan="6" className="empty-state">
                    No brands found
                  </td>
                </tr>
              ) : (
                filteredBrands.map((brand) => (
                  <tr key={brand.id}>
                    <td>{brand.brandId}</td>
                    <td>{brand.name}</td>
                    <td>{brand.slug}</td>
                    <td>{brand.description || "-"}</td>
                    <td>
                      {brand.imageUrl ? (
                        <img
                          src={brand.imageUrl}
                          alt={brand.name}
                          className="brand-image"
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      <div className="action-buttons">
                        <Link
                          to={`/admin/brands/${brand.id}/edit`}
                          className="btn-edit"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() => handleDelete(brand.id)}
                          className="btn-delete"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Brands;

